import type { Permission } from '@kdk/shared';
import type { ComponentType } from 'react';

export type AdminPage = {
  /** `/admin/<path>` */
  path: string;
  label: string;
  permission: Permission;
  load: () => Promise<{ Component: ComponentType }>;
};

/** 各管理ページの Task で、ここに自分の 1 件を追加する。表示順 = 配列順。 */
export const ADMIN_PAGES: readonly AdminPage[] = [
  {
    path: 'tasks',
    label: '業務マスタ管理',
    permission: 'tasks:write',
    load: async () => ({
      Component: (await import('../features/admin/tasks/TasksAdminPage')).TasksAdminPage,
    }),
  },
  {
    path: 'schedule',
    label: '推進スケジュール管理',
    permission: 'schedule:write',
    load: async () => ({
      Component: (await import('../features/admin/schedule/ScheduleAdminPage')).ScheduleAdminPage,
    }),
  },
  {
    path: 'cases',
    label: '案件管理',
    permission: 'cases:write',
    load: async () => ({
      Component: (await import('../features/admin/cases/CasesAdminPage')).CasesAdminPage,
    }),
  },
  {
    path: 'staff',
    label: '社員管理',
    permission: 'staff:write',
    load: async () => ({
      Component: (await import('../features/admin/staff/StaffAdminPage')).StaffAdminPage,
    }),
  },
  {
    path: 'allocations',
    label: '配置修正',
    permission: 'allocations:write',
    load: async () => ({
      Component: (await import('../features/admin/allocations/AllocationsAdminPage'))
        .AllocationsAdminPage,
    }),
  },
  {
    path: 'accounts',
    label: 'アカウント管理',
    permission: 'accounts:write',
    load: async () => ({
      Component: (await import('../features/admin/accounts/AccountsAdminPage')).AccountsAdminPage,
    }),
  },
];
